import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M9.237 6.002v11.153H0zm0-4.002A4.62 4.62 0 0 1 0 2zm1.523 15.155a4.616 4.616 0 0 1 4.619-4.619 4.62 4.62 0 0 1 4.618 4.619zm0-4.005V2h9.237z" }));
const SvgZendeskDarkmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgZendeskDarkmode;
